import { FC, ReactNode } from 'react';
import { GuestBarLayoutMobile } from './GuestBarLayoutMobile';
import { GuestBarLayoutDesktop } from './GuestBarLayoutDesktop';

export interface GuestBarLayoutProps {
  slot1: ReactNode;
  slot2: ReactNode;
  slot3: ReactNode;
  isMobile: boolean;
}

export const GuestBarLayout: FC<GuestBarLayoutProps> = ({ slot1, slot2, slot3, isMobile, ...rest }) =>
  isMobile ? (
    <GuestBarLayoutMobile
      leftColumn={
        <>
          {slot1}
          {slot2}
        </>
      }
      rightColumn={slot3}
      {...rest}
    />
  ) : (
    <GuestBarLayoutDesktop {...rest}>
      {slot1}
      {slot2}
      {slot3}
    </GuestBarLayoutDesktop>
  );
